import React from "react";
import { Loader } from "lucide-react";
import { StatusBadge } from "./badges";

function fmtETA(ts) {
    if (!ts) return "—";
    try {
        const ms = ts?.seconds ? ts.seconds * 1000 : new Date(ts).getTime();
        return isNaN(ms) ? "—" : new Date(ms).toLocaleDateString("en-AU", { day:"2-digit", month:"short", year:"numeric" });
    } catch { return "—"; }
}

function dotColor(status) {
    if (["delivered","completed","validated","approved"].includes(status)) return "#10B981";
    if (["delayed","in_transit","on_water","submitted","arrived"].includes(status)) return "#3B82F6";
    if (["exception","customs_hold","rejected","cancelled"].includes(status)) return "#EF4444";
    return "#6B7280";
}

// Most recent platform shipments + ASNs (Firestore, from /api/control-tower/summary)
export default function PlatformShipmentsTable({ shipments, loading }) {
    return (
        <div className="overflow-auto max-h-[70vh] overscroll-contain">
            <table className="w-full text-left text-xs">
                <thead className="sticky top-0 z-10 shadow-[0_1px_0_#1F2937]">
                    <tr className="border-t border-[#1F2937] bg-[#0D1520]">
                        {["Ref","Supplier","Origin","Destination","Mode","Vessel / ASN","ETA","Status","Milestone"].map(h => (
                            <th key={h} className="px-4 py-2.5 text-[10px] font-bold text-slate-500 uppercase tracking-wider whitespace-nowrap">{h}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="divide-y divide-[#1F2937]">
                    {loading ? (
                        <tr>
                            <td colSpan={9} className="px-4 py-10 text-center">
                                <Loader size={20} className="animate-spin mx-auto text-slate-700"/>
                            </td>
                        </tr>
                    ) : shipments.length === 0 ? (
                        <tr>
                            <td colSpan={9} className="px-4 py-8 text-center text-slate-500 text-sm">
                                No shipments or ASNs found. Create some to see live data here.
                            </td>
                        </tr>
                    ) : shipments.map(s => (
                        <tr key={s.id} className="hover:bg-[#1F2937]/40 transition-colors">
                            <td className="px-4 py-3">
                                <div className="flex items-center gap-2">
                                    <span className="w-2 h-2 rounded-full shrink-0" style={{backgroundColor:dotColor(s.status)}}/>
                                    <span className="font-mono font-semibold text-slate-200 text-[11px]">{s.ref}</span>
                                </div>
                            </td>
                            <td className="px-4 py-3 text-slate-300 max-w-[110px] truncate">{s.supplier}</td>
                            <td className="px-4 py-3 text-slate-400 whitespace-nowrap">{s.origin}</td>
                            <td className="px-4 py-3 text-slate-400 whitespace-nowrap">{s.destination}</td>
                            <td className="px-4 py-3 text-slate-400">{s.mode}</td>
                            <td className="px-4 py-3 text-slate-400 max-w-[120px] truncate">{s.vessel}</td>
                            <td className="px-4 py-3 text-slate-300 whitespace-nowrap">{fmtETA(s.eta)}</td>
                            <td className="px-4 py-3"><StatusBadge status={s.status}/></td>
                            <td className="px-4 py-3 text-slate-400">{s.milestone}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
